import { submitToApi } from 'awsApi'
import { URL } from './endpoints'
import { getProfile } from './profile'

export const ACTIONS = {
    GET_EMPLOYEE: {
        START: 'GET_EMPLOYEE START',
        SUCCESS: 'GET_EMPLOYEE SUCCESS',
        FAILURE: 'GET_EMPLOYEE FAILURE',
    },
    POST_APPRECIATION: {
        START: 'POST_APPRECIATION START',
        SUCCESS: 'POST_APPRECIATION SUCCESS',
        FAILURE: 'POST_APPRECIATION FAILURE',
    },
    POST_REWARD: {
        START: 'POST_REWARD START',
        SUCCESS: 'POST_REWARD SUCCESS',
        FAILURE: 'POST_REWARD FAILURE',
    },
    GET_APPRECIATIONS: {
        START: 'GET_APPRECIATIONS START',
        SUCCESS: 'GET_APPRECIATIONS SUCCESS',
        FAILURE: 'GET_APPRECIATIONS FAILURE',
    },
    REPORT_APPRECIATION: {
        START: 'REPORT_APPRECIATION START',
        SUCCESS: 'REPORT_APPRECIATION SUCCESS',
        FAILURE: 'REPORT_APPRECIATION FAILURE',
    },
}

export const getActiveEmployees =
    ({ email }) =>
    async dispatch => {
        dispatch({ type: ACTIONS.GET_EMPLOYEE.START })
        try {
            const { payload } = await submitToApi({
                path: URL.APPRECIATION.V6_APPRECIATION_GET_EMPLOYEE,
                url: URL.APPRECIATION.BASE,
                query: { email },
            })
            dispatch({ type: ACTIONS.GET_EMPLOYEE.SUCCESS, data: payload.data })
        } catch (error) {
            console.log('error', error)
            dispatch({ type: ACTIONS.GET_EMPLOYEE.FAILURE, error })
        }
    }
export const addAppreciation =
    ({ appreciation, clientId }) =>
    async dispatch => {
        dispatch({ type: ACTIONS.POST_APPRECIATION.START })
        try {
            const { payload } = await submitToApi({
                body: appreciation,
                method: 'POST',
                path: URL.APPRECIATION.V6_POST_APPRECIATION,
                url: URL.APPRECIATION.BASE,
            })
            dispatch({ type: ACTIONS.POST_APPRECIATION.SUCCESS, data: payload.data })
            dispatch(getAppreciation(clientId))
        } catch (error) {
            dispatch({ type: ACTIONS.POST_APPRECIATION.FAILURE, error })
        }
    }

export const getAppreciation = clientId => async dispatch => {
    dispatch({ type: ACTIONS.GET_APPRECIATIONS.START })
    try {
        const data = await submitToApi({
            path: URL.APPRECIATION.V6_POST_APPRECIATION,
            url: URL.APPRECIATION.BASE,
            query: { clientId },
        })
        dispatch({ type: ACTIONS.GET_APPRECIATIONS.SUCCESS, data: data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_APPRECIATIONS.FAILURE, error })
    }
}

export const reportAppreciation =
    ({ reportedAppreciation, clientId }) =>
    async dispatch => {
        dispatch({ type: ACTIONS.REPORT_APPRECIATION.START })
        try {
            const { payload } = await submitToApi({
                body: reportedAppreciation,
                method: 'PUT',
                path: URL.APPRECIATION.V6_POST_APPRECIATION,
                url: URL.APPRECIATION.BASE,
            })
            dispatch({ type: ACTIONS.REPORT_APPRECIATION.SUCCESS, data: payload.data })
            dispatch(getAppreciation(clientId))
        } catch (error) {
            dispatch({ type: ACTIONS.REPORT_APPRECIATION.FAILURE, error })
        }
    }
export const addReward = (reward, clientId) => async dispatch => {
    dispatch({ type: ACTIONS.POST_REWARD.START })
    try {
        const { payload } = await submitToApi({
            body: reward,
            method: 'POST',
            path: URL.REWARDS.V6_POST_REWARD,
            url: URL.REWARDS.BASE,
            query: { clientId },
        })
        dispatch({ type: ACTIONS.POST_REWARD.SUCCESS, data: payload.data })
        dispatch(getProfile())
    } catch (error) {
        dispatch({ type: ACTIONS.POST_REWARD.FAILURE, error })
    }
}
